import {useEffect, useState} from "react";
import CGT from '../../utils/CGT.ts';

let init = CGT.now();
export default function SWCClock ({className}) {
    const [time, setTime] = useState(init);

    useEffect(() => {
        const updateTime = () => {
            setTime(CGT.now());
        }
        const id = setInterval(updateTime, 60);
        return () => clearInterval(id);
    }, []);

    return (<div className={className} style={{fontSize: '0.875rem'}}><i>{time.toCGT()}</i></div>);
}
